import React from 'react';
import { observer } from 'mobx-react';

import { AppRedirect, routeNaming, AppLink } from '../../routes';
import { SessionStore } from '../../stores/SessionStore';
import { HomeNavbar } from '../../common/home-navbar';
import { BasicInput } from '../../common/basic-input';
import { SecondaryButton } from '../../common/secondary-button';
import styles from './Login.css';
import { Modal } from '../../common/modal';
import { Storage } from '../../helpers/Storage';
import { SimpleButton } from '../../common/simple-button';
import { SEO } from '../../common/seo';

const Login = observer(class Login extends React.Component {
  static clearResetPassword() {
    SessionStore.resetRegisterErrors();
  }
  constructor(props) {
    super(props);
    this.state = {
      identification: null,
      password: '',
      resetPassword: false,
    };

    this._onSubmit = this._onSubmit.bind(this);
    this._updateIdentification = this._updateIdentification.bind(this);
    this._updatePassword = this._updatePassword.bind(this);
    this._redirectToResetPassword = this._redirectToResetPassword.bind(this);
  }

  _updateIdentification(event) {
    const identification = event.target.value;
    this.setState({
      identification,
    });
  }

  _updatePassword(event) {
    const password = event.target.value;
    this.setState({
      password,
    });
  }

  _dataValid() {
    return !!this.state.identification;
  }

  _onSubmit(event) {
    event.preventDefault();
    if (!this._dataValid()) {
      return;
    }
    SessionStore.login(this.state.identification, this.state.password);
  }

  _redirectToResetPassword() {
    Login.clearResetPassword();
    this.setState({ resetPassword: true });
  }

  render() {
    const DISABLED_COOKIES_MESSAGE = 'Debes habilitar las cookies en tu navegador para acceder a ciertas funcionalidades.';
    if (SessionStore.loggedIn) {
      return (
        <AppRedirect routeName={routeNaming.LOGIN_VALIDATOR} />
      );
    }
    if (this.state.resetPassword) {
      return (
        <AppRedirect
          routeName={routeNaming.CHANGE_PASSWORD}
          queryParams={{ token: SessionStore.resetToken }}
        />
      );
    }
    return (
      <div className={styles.container}>
        <SEO
          title="Inicia sesión"
          description="Inicia sesión en Carlos Gutiérrez S.A. para acceder a tu cuenta y disfrutar de una experiencia personalizada. Ingresa tus credenciales de manera rápida y segura para gestionar tus datos, realizar compras, seguir tus actividades y recibir notificaciones exclusivas. Si aún no tienes una cuenta, regístrate ahora para comenzar a disfrutar de todos nuestros servicios. Recupera tu contraseña si la has olvidado y mantén tu acceso sin problemas. ¡Bienvenido a Carlos Gutiérrez S.A., tu espacio digital personalizado!"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainContent}>
          <div className={styles.internalContainer}>
            <div className={styles.section}>
              <h3 className={styles.title}>
                Ingresar
              </h3>
              <form onSubmit={this._onSubmit}>
                <BasicInput
                  className={styles.input}
                  label="Email / Documento / RUT"
                  name="identification"
                  onChange={this._updateIdentification}
                />
                <BasicInput
                  className={styles.input}
                  label="Contraseña"
                  name="password"
                  type="password"
                  onChange={this._updatePassword}
                />
                {
                  !!SessionStore.registerAuthError &&
                  <p className={styles.errorMessage}>
                    No se pudo completar la autenticación. Por favor, intente nuevamente y
                    si el problema persiste, contacte con nuestro área de atención al cliente
                    para recibir asistencia.
                  </p>
                }
                {SessionStore.internalError &&
                <p className={styles.errorMessage}>
                  Estamos experimentando algunas dificultades en nuestro sitio.
                  Por favor intente nuevamente en unos momentos.
                </p>}
                {
                  SessionStore.error &&
                  <p className={styles.errorMessage}>
                    {SessionStore.error.message}
                  </p>
                }
                {
                  !Storage.isAvailable &&
                  <p className={styles.errorMessage}>
                    {DISABLED_COOKIES_MESSAGE}
                  </p>
                }
                <SecondaryButton
                  className={styles.submitButton}
                  disabled={!this._dataValid() || !Storage.isAvailable}
                >
                  Ingresar
                </SecondaryButton>
                <AppLink
                  className={styles.forgotPasswordLink}
                  routeName={routeNaming.FORGOT_PASSWORD}
                >
                  ¿Olvidaste tu contraseña?
                </AppLink>
              </form>
            </div>
            <div className={styles.section}>
              <h3 className={styles.title}>
                Nuevo cliente
              </h3>
              {
                !Storage.isAvailable &&
                <p className={styles.errorMessage}>
                  {DISABLED_COOKIES_MESSAGE}
                </p>
              }
              <AppLink routeName={routeNaming.REGISTER} className={styles.submitLink}>
                <SecondaryButton
                  className={styles.submitButton}
                  disabled={!Storage.isAvailable}
                >
                  Crear Una Cuenta
                </SecondaryButton>
              </AppLink>
            </div>
          </div>
        </div>
        { !!SessionStore.haveToResetPassword &&
          <Modal>
            <div className={styles.modalChildren}>
              <p className={styles.modalTitle}>
                Por motivos de seguridad es necesario que cambie su contraseña
              </p>
              <div className={styles.modalButtonsSection}>
                <SimpleButton
                  className={styles.modalButton}
                  onClick={Login.clearResetPassword}
                >
                  Cancelar
                </SimpleButton>
                <SimpleButton
                  className={styles.modalButtonAccept}
                  onClick={this._redirectToResetPassword}
                >
                  Aceptar
                </SimpleButton>
              </div>
            </div>
          </Modal>
        }
      </div>
    );
  }
});

export { Login };



// WEBPACK FOOTER //
// ./src/pages/login/Login.jsx